import React from 'react'

import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Panel from '../structure/Panel'
import { COLORS } from '@btime/constants'

export const Col = ({ children, ...props }) => {
  return (
    <FlexCol flex={1} {...props}>
      {children}
    </FlexCol>
  )
}

export const Row = ({ children, head, bgColor, leftBorderColor }) => {
  return (
    <Panel
      noMargin
      mediumPadding
      bgColor={bgColor || COLORS.transparent}
      lineBorder={!head}
      noRadius={head}
      noShadow={head}
      noPaddingBottom={head}
      borderLeftColor={head ? COLORS.transparent : leftBorderColor || COLORS.light3}
    >
      <FlexGrid justify="space-between" gutter={0.5}>
        {children}
      </FlexGrid>
    </Panel>
  )
}

const FlexTable = ({ children }) => {
  return (
    <div className="flexTable">
      <FlexGrid gutter={0.3} direction="column" align="stretch" justify="flex-start">
        {children}
      </FlexGrid>
    </div>
  )
}

export default FlexTable
